"use strict";
// Lint issue is because there is 1 item currently. We do not want to default export it.
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=index.js.map